import style from "./style.module.scss";
import empty from "../../img/infinity.svg";
import {Event, setChecked} from "../../store/app";
import {useStore} from "effector-react";
import {$store} from "../../store";
import moment from "moment";

const SportBlock = (props:{event:Event, index:number}) => {

	const store = useStore($store);

	const teamA = props.event.competitors[0].logo_base64;
	const teamB = props.event.competitors[1].logo_base64;

	return (
		<div className={style.sportBlock}>
			<div className={style.header}>
				<p>{props.event.name}</p>
			</div>
			<div className={style.content}>
				<div className={style.event}>
					<div className={style.team}>
						<img src={teamA} alt=""/>
						<p>{props.event.competitors[0].name}</p>
					</div>
					<div className={style.date}>
						<p>{moment(props.event.date*1000).format("MMM D")}</p>
						<p className={style.time}>{moment(props.event.date*1000).format("HH:mm")}</p>
					</div>
					<div className={style.team}>
						<img src={teamB} alt=""/>
						<p>{props.event.competitors[1].name}</p>
					</div>
				</div>
				<div className={style.wrap}>
					<span className={style.outcomes}>
						<div onClick={()=>{ setChecked({ id:props.event.outcomes[0].id, index:props.index }) }} className={`${style.el} ${store.app.checked[props.index]?.id===props.event.outcomes[0].id && style.active}`}>{props.event.outcomes[0].name}</div>
						<div onClick={()=>{ setChecked({ id:props.event.outcomes[1].id, index:props.index }) }} className={`${style.el} ${store.app.checked[props.index]?.id===props.event.outcomes[1].id && style.active}`}>{props.event.outcomes[1].name}</div>
						<div onClick={()=>{ setChecked({ id:props.event.outcomes[2].id, index:props.index }) }} className={`${style.el} ${store.app.checked[props.index]?.id===props.event.outcomes[2].id && style.active}`}>{props.event.outcomes[2].name}</div>
					</span>
					<span className={style.result}>
						<p>Верный исход</p>
						{
							props.event.outcome_win
								? <p>{props.event.outcome_win}</p>
								: <img src={empty} alt=""/>
						}

					</span>
				</div>
			</div>
		</div>
	);
};

export default SportBlock;
